<template>
<div class="chapter">
<div class="inner_page">
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_3"> </p>
<p class="block_5">For John Larson</p>
<p class="block_1"> </p>
<p class="block_5">And in memory of John Sumakis, aka David Thomas Lord</p>
<p class="block_1"> </p>
<p class="block_1"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_6" id="calibre_pb_2"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_002.vue?38da49e9